import script from "./nueva.vue?vue&type=script&setup=true&lang=js"
export * from "./nueva.vue?vue&type=script&setup=true&lang=js"

import "./nueva.vue?vue&type=style&index=0&id=7ee3af3f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee3af3f"]])

export default __exports__